import * as React from 'react';

interface Props {
    stroke?: string;
}

const SvgScrollDownSmall: React.FC<Props> = (
    props: React.SVGProps<SVGSVGElement>
) => {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 28.67 15.33">
            <path
                fill="none"
                stroke={props.stroke || '#505251'}
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth={2}
                d="M27.66 1L14.33 14.33 1 1"
                data-name="Layer 2"
            />
        </svg>
    );
};

export default SvgScrollDownSmall;
